import { Component, Input, Output, EventEmitter } from '@angular/core';

import { DataManager } from "techlify-ng";
import { AlertService } from "techlify-ng";
import { RequestErrorService } from "techlify-ng";

import { Occupation } from "./occupation.model";

/**
 * Controller used to edit a Occupation
 * 
 * @author Floyd Kissoon
 * @since 20180703
 */
@Component({
    selector: 'occupation-edit',
    templateUrl: "./occupation-form.html"
})
export class OccupationEditComponent
{

    @Input() occupation: Occupation;
    @Output() onSave = new EventEmitter<Occupation>();
    private isWorking = false;
    
    constructor(private dataManager: DataManager, private alertService: AlertService,
    private errorHandler: RequestErrorService) { }

    save()
    {
        this.isWorking = true;
        this.dataManager.PUT("api/occupation/" + this.occupation.id, this.occupation).then(
            res =>
            {
                this.onSave.emit(res.occupation);
                this.alertService.addAlert(res.message, "success");
                this.isWorking = false;
            },
            error =>
            {
                this.errorHandler.handleError(error);
                this.isWorking = false;
            }
        );
    }
}